import { render, staticRenderFns } from "./CompanyReportTabOrders.vue?vue&type=template&id=c906195a"
import script from "./CompanyReportTabOrders.vue?vue&type=script&lang=js"
export * from "./CompanyReportTabOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports